// src/pages/Faq.js
// Pagina FAQ con domande frequenti su FantaWrestling
import React, { useState, useEffect } from 'react';
import { auth } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';

// FAQ_LIST aggiornata
const FAQ_LIST = [
  {
    question: "❓ Cos'è il FantaWrestling e come funziona?",
    answer: (
      <div>
        <p>Il FantaWrestling è un gioco basato su eventi e risultati degli show di Pro Wrestling. Ogni partecipante è il proprietario di una fazione e sceglie i membri che la compongono.</p>
        <p className="mt-2"><strong>Modalità di gioco:</strong></p>
        <ul>
          <li><strong>🏆 Competitiva:</strong> Massima personalizzazione, asta tra partecipanti, ogni wrestler può essere posseduto da una sola fazione. Adatta a roster privati (6-12 partecipanti).</li>
          <li><strong>📋 Indipendente:</strong> Regole standard, acquisti da listone unico condiviso, lo stesso wrestler può essere acquistato da più giocatori. Ideale per grandi gruppi (anche centinaia di partecipanti). È l'unica modalità giocabile sia in versione pubblica che privata.</li>
          <li><strong>👑 GM (General Manager):</strong> Un GM gestisce i match (casuale o su sua decisione), permettendo scontri diretti tra avversari. La classifica si basa sui match vinti, non sui punti delle fazioni.</li>
          <li><strong>🛣️ Road To:</strong> Modalità speciale e temporanea, attivata in periodi particolari (es. Road to WrestleMania, Road to SummerSlam). Ha durata definita con inizio e fine prestabiliti.</li>
        </ul>
      </div>
    )
  },
  {
    question: "💰 Come funzionano i crediti e gli acquisti?",
    answer: (
      <div>
        <p>Ogni fazione parte con un budget iniziale di crediti per acquistare i wrestler.</p>
        <ul>
          <li><strong>Modalità Indipendente:</strong> Acquisti da listone unico condiviso. Svincoli/acquisti in qualsiasi momento con un massimo di 8 operazioni (prima dell'inizio dei punteggi sono illimitati).</li>
          <li><strong>Modalità Competitiva:</strong> Assegnazione wrestler mediante asta tra i partecipanti. Svincoli/acquisti solo in aste programmate. Scambi consentiti tra giocatori dopo un'asta (da comunicare).</li>
        </ul>
        <p className="mt-2">I wrestler svincolati salvano il punteggio ottenuto fino a quel momento nella fazione; i nuovi acquisti partono da 0 punti.</p>
      </div>
    )
  },
  {
    question: "📊 Come vengono assegnati i punti?",
    answer: (
      <div>
        <p>I punti vengono assegnati in base a bonus e malus durante gli show. La competizione inizia in una data predefinita e termina con WrestleMania.</p>
        <p className="mt-2"><strong>Cosa viene considerato:</strong></p>
        <ul>
          <li>Tutte le superstar WWE (Main Roster e NXT)</li>
          <li>Show WWE, NXT, AAA e TNA (settimanali, eventi speciali e PLE/PPV)</li>
          <li>Titoli: Main Roster, NXT, TNA e AAA (massimi, singoli e tag team, maschili e femminili)</li>
        </ul>
        <p className="mt-2">I punti <strong>non sono retroattivi</strong>. Vince chi totalizza più punti a fine stagione.</p>
      </div>
    )
  },
  {
    question: "👥 Come si compone una fazione?",
    answer: (
      <div>
        <p><strong>Modalità Indipendente:</strong></p>
        <ul>
          <li>6 wrestler totali</li>
          <li>Minimo 2 di sesso opposto</li>
        </ul>
        <p><strong>Modalità Competitiva:</strong></p>
        <ul>
          <li>6-8 wrestler totali</li>
          <li>Minimo 2-3 di sesso opposto</li>
          <li>Proporzione inversa con numero partecipanti</li>
        </ul>
        <p>Ogni wrestler vale come singolo, anche se parte di tag team o stable. In caso di cambio gimmick, il wrestler mantiene il posto in fazione.</p>
      </div>
    )
  },
  {
    question: "🏆 Cosa succede a fine stagione?",
    answer: (
      <div>
        <p>Al termine di WrestleMania, il giocatore con il maggior numero di punti vince la competizione.</p>
        <p className="mt-2">Il vincitore ha diritto di mantenere un wrestler nella propria fazione per la stagione successiva allo stesso prezzo pagato all'asta (modalità competitiva) o al costo di acquisto (modalità indipendente).</p>
      </div>
    )
  },
  {
    question: "📱 Come posso contattare lo staff?",
    answer: (
      <div>
        <p>Puoi contattarci attraverso:</p>
        <ul>
          <li><i className="bi bi-instagram me-2"></i> Instagram: <a href="https://www.instagram.com/fanta.wrestling/" target="_blank" rel="noopener noreferrer">@fanta.wrestling</a></li>
          <li><i className="bi bi-telegram me-2"></i> Telegram: <a href="https://t.me/fantawrestlingchat" target="_blank" rel="noopener noreferrer">t.me/fantawrestlingchat</a></li>
          <li><i className="bi bi-envelope me-2"></i> Email: <a href="mailto:fantafwi@gmail.com">fantafwi@gmail.com</a></li>
        </ul>
        <p className="mt-2">Puoi anche inviarci una domanda direttamente dal form qui sotto!</p>
      </div>
    )
  },
  {
    question: "🔄 Posso modificare la mia fazione durante la stagione?",
    answer: (
      <div>
        <p><strong>Modalità Indipendente:</strong> Sì, puoi svincolare e acquistare wrestler in qualsiasi momento, con un massimo di 8 operazioni totali. Prima dell'inizio dei punteggi (primo PLE disponibile) le operazioni sono illimitate.</p>
        <p><strong>Modalità Competitiva:</strong> Gli svincoli e gli acquisti sono consentiti solo durante le aste programmate. Gli scambi tra giocatori sono permessi previa comunicazione allo staff.</p>
      </div>
    )
  },
  {
    question: "🎯 Quali bonus/malus vengono applicati?",
    answer: (
      <div>
        <p>I bonus/malus vengono applicati in base a eventi durante i match:</p>
        <ul>
          <li><strong>Vittoria:</strong> Punti positivi per chi vince</li>
          <li><strong>Sconfitta:</strong> Punti negativi per chi perde</li>
          <li><strong>Titoli:</strong> Bonus per mantenimento o conquista titoli</li>
          <li><strong>Interferenze attive:</strong> Bonus per chi interferisce attivamente</li>
          <li><strong>Spacca oggetto/ring:</strong> Bonus per chi rompe oggetti o il ring</li>
          <li><strong>Botch:</strong> Malus per errori evidenti</li>
          <li><strong>Voto MaxisAwesome92:</strong> Bonus basato sul voto del match (max 5 stelle)</li>
        </ul>
        <p className="mt-2">Consulta la tabella completa nella sezione "Sistema Punteggi" delle Regole.</p>
      </div>
    )
  }
];

export default function Faq() {
  const [userEmail, setUserEmail] = useState('');
  const [emailInput, setEmailInput] = useState('');
  const [questionText, setQuestionText] = useState('');
  const [activeAccordion, setActiveAccordion] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, user => {
      if (user && user.email) {
        setUserEmail(user.email);
      }
      unsubscribe();
    });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const to = "fantafwi@gmail.com";
    const from = userEmail || emailInput;
    const subject = encodeURIComponent("Nuova domanda FAQ");
    const body = encodeURIComponent(`Da: ${from}\n\nDomanda:\n${questionText}`);
    window.location.href = `mailto:${to}?subject=${subject}&body=${body}`;
  };

  const toggleAccordion = (idx) => {
    setActiveAccordion(prev => prev === idx ? null : idx);
  };

  return (
    <div className="faq-page" style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
      padding: '2rem 0'
    }}>
      <div className="container py-5">
        {/* Header migliorato */}
        <div className="text-center">
          <h1 className="mb-3 fw-bold text-center text-brand-secondary" style={{
            fontFamily: "'Cinzel Decorative'",
            textShadow: '1px 1px 2px rgba(0, 0, 0)'
          }}>
            <i className="bi bi-question-lg me-3" style={{
              fontSize: '3rem',
              filter: 'drop-shadow(0 2px 4px rgba(194, 157, 84, 0.4))'
            }}></i>Domande frequenti
          </h1>
          <p className="lead position-relative mt-3" style={{
            color: 'var(--brand-primary)',
            fontSize: '1.1rem',
            opacity: 0.8
          }}>
            Tutte le risposte alle tue domande su FantaWrestling
          </p>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="accordion mb-5 faq-accordion" id="faqAccordion">
              {FAQ_LIST.map((item, idx) => (
                <div
                  key={idx}
                  className="accordion-item border-0 mb-4 overflow-hidden faq-item faq-accordion-item"
                  style={{
                    borderRadius: 'var(--border-radius)',
                    background: 'white',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                    transition: 'var(--transition)',
                    borderTop: activeAccordion === idx ? '3px solid var(--brand-secondary)' : '3px solid var(--brand-primary)'
                  }}
                >
                  <h2 className="accordion-header" id={`faqHeading${idx}`}>
                    <button
                      className={`accordion-button ${activeAccordion === idx ? '' : 'collapsed'} fw-semibold faq-accordion-button`}
                      type="button"
                      onClick={() => toggleAccordion(idx)}
                      aria-expanded={activeAccordion === idx}
                      aria-controls={`faqCollapse${idx}`}
                      style={{
                        borderRadius: '0.5rem',
                        background: activeAccordion === idx ? 'linear-gradient(135deg, rgba(38, 56, 72, 0.08) 0%, rgba(38, 56, 72, 0.04) 100%)' : '#fff',
                        color: 'var(--brand-primary)',
                        transition: 'var(--transition)',
                        boxShadow: 'none',
                        borderBottom: 'none'
                      }}
                    >
                      <span className="flex-grow-1 text-start">{item.question}</span>
                    </button>
                  </h2>
                  <div
                    id={`faqCollapse${idx}`}
                    className={`accordion-collapse collapse ${activeAccordion === idx ? 'show' : ''}`}
                    aria-labelledby={`faqHeading${idx}`}
                    style={{
                      maxHeight: activeAccordion === idx ? '500px' : '0px',
                      overflow: 'hidden',
                      transition: 'max-height 0.4s cubic-bezier(0.65, 0, 0.35, 1)'
                    }}
                  >
                    <div
                      className="accordion-body faq-accordion-body"
                      style={{
                        background: 'rgba(38, 56, 72, 0.02)',
                        color: 'var(--brand-primary)',
                        borderTop: '1px solid rgba(38, 56, 72, 0.1)',
                        opacity: activeAccordion === idx ? 1 : 0,
                        transform: activeAccordion === idx ? 'translateY(0)' : 'translateY(-10px)',
                        transition: 'opacity 0.3s ease, transform 0.3s ease',
                        transitionDelay: activeAccordion === idx ? '0.1s' : '0s'
                      }}
                    >
                      {item.answer}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="card border-0 p-4 mb-5 faq-contact-card" style={{
              background: 'white',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
              borderRadius: 'var(--border-radius)',
              borderTop: '4px solid var(--brand-secondary)'
            }}>
              <div className="card-body">
                <h5 className="fw-bold mb-4 text-center" style={{ color: 'var(--brand-primary)' }}>Altre domande?</h5>
                <p className="text-center mb-4" style={{ color: 'var(--brand-primary)', opacity: 0.8 }}>Inviaci la tua domanda e ti risponderemo al più presto!</p>
                <form onSubmit={handleSubmit}>
                  {!userEmail && (
                    <div className="mb-4">
                      <label htmlFor="email" className="form-label fw-semibold" style={{ color: 'var(--brand-primary)' }}>La tua email</label>
                      <input
                        type="email"
                        id="email"
                        className="form-control py-2 faq-control"
                        value={emailInput}
                        onChange={e => setEmailInput(e.target.value)}
                        required
                        placeholder="tua@email.com"
                        style={{
                          borderColor: 'rgba(38, 56, 72, 0.2)',
                          borderRadius: '0.5rem'
                        }}
                      />
                    </div>
                  )}
                  <div className="mb-4">
                    <label htmlFor="question" className="form-label fw-semibold" style={{ color: 'var(--brand-primary)' }}>La tua domanda</label>
                    <textarea
                      id="question"
                      className="form-control py-2 faq-control"
                      rows="4"
                      value={questionText}
                      onChange={e => setQuestionText(e.target.value)}
                      required
                      placeholder="Scrivi qui la tua domanda..."
                      style={{
                        borderColor: 'rgba(38, 56, 72, 0.2)',
                        borderRadius: '0.5rem'
                      }}
                    />
                  </div>
                  <div className="d-grid">
                    <button type="submit" className="py-2 fw-semibold faq-submit-btn" style={{
                      background: 'linear-gradient(135deg, var(--brand-primary), var(--brand-primary-light))',
                      color: 'white',
                      border: 'none',
                      borderRadius: '0.5rem',
                      cursor: 'pointer',
                      transition: 'var(--transition)',
                      fontSize: '1rem'
                    }} onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'} onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}>
                      <i className="bi bi-send-fill me-2"></i> Invia domanda
                    </button>
                  </div>
                </form>
              </div>
              <div className="text-center">
                <h6 className="fw-bold mb-3" style={{ color: 'var(--brand-primary)' }}>Unisciti alla nostra community!</h6>
              <div className="d-flex justify-content-center gap-3 flex-wrap mt-4">
                <a
                  href="https://t.me/fantawrestlingchat"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-3 py-2 d-flex align-items-center justify-content-center gap-2 shadow-sm faq-social-pill"
                  style={{
                    borderRadius: '2rem',
                    minWidth: 80,
                    fontSize: '1rem',
                    background: 'linear-gradient(135deg, #2AABEE, #229ED9)',
                    color: 'black',
                    border: 'none',
                    textDecoration: 'none',
                    transition: 'var(--transition)',
                    cursor: 'pointer'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-3px)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                  title="Instagram"
                >
                  <i className="bi bi-telegram"></i> Telegram
                </a>
                <a
                  href="https://www.instagram.com/fanta.wrestling/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-3 py-2 d-flex align-items-center justify-content-center gap-2 shadow-sm faq-social-pill"
                  style={{
                    borderRadius: '2rem',
                    minWidth: 80,
                    fontSize: '1rem',
                    background: 'linear-gradient(135deg,  #5851DB, #C13584, #E1306C, #F56040, #FCAF45)',
                    color: '#fff',
                    border: 'none',
                    textDecoration: 'none',
                    transition: 'var(--transition)',
                    cursor: 'pointer'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-3px)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                  title="Instagram"
                >
                  <i className="bi bi-instagram"></i> Instagram
                </a>
                <a
                  href="mailto:fantafwi@gmail.com"
                  className="px-3 py-2 d-flex align-items-center justify-content-center gap-2 shadow-sm faq-social-pill"
                  style={{
                    borderRadius: '2rem',
                    minWidth: 80,
                    fontSize: '1rem',
                    background: 'linear-gradient(135deg, #b81414, #f53939)',
                    color: 'white',
                    border: 'none',
                    textDecoration: 'none',
                    transition: 'var(--transition)',
                    cursor: 'pointer'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-3px)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                  title="Email"
                >
                  <i className="bi bi-envelope"></i> Email
                </a>
              </div>
              </div>
            </div>
          </div>
        </div>

        {/* Animazioni CSS */}
        <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-8px); }
        }
        .animate-float {
          animation: float 3s ease-in-out infinite;
        }
        .text-gradient-primary {
          background: linear-gradient(135deg, var(--brand-primary) 0%, var(--brand-secondary) 100%);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
          display: inline-block;
        }
        .transition-all {
          transition: all 0.3s ease;
        }
        .accordion-button:not(.collapsed) {
          color: var(--brand-primary);
          box-shadow: none;
        }
        .accordion-button:focus {
          box-shadow: none;
          border-color: rgba(38, 56, 72, 0.3);
        }
        .faq-item:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(0,0,0,0.12);
        }
      `}</style>
      </div>
    </div>
  );
}
